import { LogoMark } from "./Logo";
import { useLang } from "@/lib/i18n";

export default function Marquee() {
  const { t } = useLang();
  const row = t.marquee.flatMap((w, i) => [
    <span key={`w${i}`} className={`font-display text-6xl font-black uppercase italic sm:text-8xl lg:text-[9rem] ${i % 2 ? "text-outline" : "text-white"}`}>{w}</span>,
    <LogoMark key={`m${i}`} className="mx-8 h-10 w-auto shrink-0 text-white sm:mx-12 sm:h-14" />,
  ]);
  return (
    <section data-testid="editorial-marquee" className="marquee-wrap overflow-hidden py-16 sm:py-24" aria-label="routes">
      <div className="marquee-track flex w-max items-center whitespace-nowrap">
        <div className="flex items-center">{row}</div>
        <div className="flex items-center" aria-hidden="true">{row}</div>
      </div>
    </section>
  );
}
